
import { StartHere } from "./StartHere";

export const Index = ( )=>{

    return(
        <>
            <StartHere/>
        </>
    )

}